import { useEffect } from "react";
import { TileLayer, useMap } from "react-leaflet";
import L from "leaflet";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";
import { MAP_CONFIG } from "../../config/api.config";

if (typeof window !== "undefined") {
  window.maplibregl = maplibregl;
}

/** Carto Positron (vector) for Light; raster tiles for Satellite. */
export default function BasemapLayer({ mapStyle = "light" }) {
  const map = useMap();
  const theme = MAP_CONFIG.TILE_THEMES[mapStyle] || MAP_CONFIG.TILE_THEMES.light;
  const isVector = theme.type === "vector";

  useEffect(() => {
    if (!isVector) return undefined;
    const layer = L.maplibreGL({
      style: theme.style,
      attribution: theme.attr,
      pane: "tilePane",
      interactive: false,
    });
    layer.addTo(map);
    return () => {
      map.removeLayer(layer);
    };
  }, [map, isVector, theme.style, theme.attr]);

  if (isVector) return null;

  return (
    <TileLayer
      url={theme.url}
      attribution={theme.attr}
      maxZoom={theme.maxZoom || 18}
      maxNativeZoom={theme.maxNativeZoom || 17}
    />
  );
}
